import { PollConfigurationBase } from "abweb/dto/generated/async/PollConfigurationBase";
export class PollConfiguration extends PollConfigurationBase {
  static createPollConfiguration(idleTimeout, sessionTimeout, isWSDisabled) {
    const retVal = new PollConfiguration();
    retVal.initPollConfiguration(idleTimeout, isWSDisabled, sessionTimeout);
    return retVal;
  }
  constructor() {
    super();
  }
}
//# sourceMappingURL=PollConfiguration.js.map
